import ApiService from "../ApiService";

const serviceHolidays = {
    getHolidays() {
        return ApiService.get(`/holidays`);
    }
};

export default serviceHolidays;